import React from 'react';
import { useLocation } from 'react-router-dom';
import { Layout, Row, Col } from 'antd';
import Sidebar from '../../components/Sidebar';
import SubscriptionList from '../profile/SubscriptionList';
import SubscriptionHistory from '../profile/SubscriptionHistory';
import ChangePasswordForm from '../../form/profile/ProfileChangePasswordForm';
const { Content } = Layout;

const Index = () => {
    const location = useLocation();
    // const [status, setStatus] = useState('current');
    const query = new URLSearchParams(location.search);
    const qs = query.get('status');
    const refNumber = query.get('ref');
    // useEffect(() => {
    //     message.loading("Loading ...", 1);
    //     if(qs === 'history'){
    //         setStatus('history');
    //     }else if(qs === 'current'){
    //         setStatus('current')
    //     }else {
    //         setStatus('change-password')
    //     }
    // }, [qs,refNumber]);

    const renderPage = (status) => {
        switch (status) {
            case 'current':
                return <SubscriptionList refNumber={refNumber} />;
            case 'history':
                return <SubscriptionHistory />;
            case 'change-password':
                return <ChangePasswordForm />;
            default:
                return <SubscriptionList refNumber={refNumber} />;
        }
    };

    return (
        <Content className="profileContainer">
            <Row justify="center" style={{ height: '100%' }}>
                <Sidebar />
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 18 }}
                    lg={{ span: 18 }}
                    xl={{ span: 18 }}
                    xxl={{ span: 18 }}
                    className="search-right"
                >
                    {/* { status === 'current' ? <SubscriptionList refNumber={refNumber} /> : <SubscriptionHistory /> } */}
                    {renderPage(qs)}
                </Col>
                <div className="clearfix"></div>
            </Row>
        </Content>
    );
};

export default Index;
